module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hr-drive-included_768.e567aa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/fullscreen-image_hr-drive-included_768.png
// module id = PPLl
// module chunks = 0